import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import placementTestReportFilterService from './PlacementTestReportFilterService';

class PlacementTestGlobalTotalService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      total: 0,
    });
  }

  load = action(() => {
    this.fetch
      .fetch({
        url: '/placement-test-report/total',
        query: {
          ...placementTestReportFilterService.form.getValues(),
          ...(placementTestReportFilterService.form.getValue('periodStart') &&
            placementTestReportFilterService.form.getValue('periodEnd') && {
              periodStart: placementTestReportFilterService.form.getValue('periodStart').format('YYYY-MM-DD'),
              periodEnd: placementTestReportFilterService.form.getValue('periodEnd').format('YYYY-MM-DD'),
            }),
        },
      })
      .then(() => {
        if (this.fetch.data) {
          this.total = this.fetch.data.total;
        } else {
          this.total = null;
        }
      });
  });
}

const placementTestGlobalTotalService = new PlacementTestGlobalTotalService();
export default placementTestGlobalTotalService;
